export const perfilLabels = {
    AUDITOR: "Auditor",
    GERENTE: "Gerente",
    ENCARREGADO: "Encarregado",
    VISITANTE: "Visitante",
};

export const perfilUsuarioOptions = [
    {
        value: 'AUDITOR',
        label: 'Auditor'
    },
    {
        value: 'GERENTE',
        label: 'Gerente'
    },
    {
        value: 'ENCARREGADO',
        label: 'Encarregado'
    },
    {
        value: 'VISITANTE',
        label: 'Visitante'
    },
    {
        value: 'ADMIN_SISTEMA',
        label: 'Administrador Sistema'
    }
];